import styled from 'styled-components';

export const RefreshBar = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;

  p {
    margin: 0;
    font-size: 13px;
  }

  /* An acceptance asks for nothing: it stays inline, understated. */
  .ok {
    color: ${({ theme }) => theme.green};
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`;

/*
 * The shared modal only forces its title and close icon to white: the body keeps Ant Design's
 * dark ink on a midnight-blue background. Fixed here, without touching the shared component.
 */
export const RefusalContent = styled('div')`
  color: ${({ theme }) => theme.white};
  font-size: 14px;

  > p {
    margin: 0 0 16px;
    color: ${({ theme }) => theme.white};
  }

  ul {
    list-style: none;
    margin: 0 0 16px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1px;
    background: ${({ theme }) => theme.light_blue_background};
    border-radius: 3px;
    overflow: hidden;
  }

  li {
    background: ${({ theme }) => theme.dark_blue_background};
    padding: 10px 14px;
    display: flex;
    gap: 10px;
    align-items: baseline;
  }

  /* The offending file first, the problem next: the left column is what gets scanned. */
  li b {
    flex: 0 0 9rem;
    color: ${({ theme }) => theme.primary_yellow};
    font-weight: 600;
  }

  .hint {
    margin: 0;
    padding-top: 14px;
    border-top: 1px solid ${({ theme }) => theme.light_blue_background};
    color: ${({ theme }) => theme.white};
    font-size: 13px;
  }

  .threshold {
    display: block;
    margin-top: 4px;
    color: ${({ theme }) => theme.pale_yellow};
  }
`;
